import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
import { KARITO_IMAGE } from '../data/content';
const principles = ['Plan with more awareness.', 'Monitor with more confidence.', 'Intervene earlier when possible.', 'Finish cases more predictably.'];
export function AboutKarito() {
  return <section className="w-full bg-ink-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-20" data-mp="2dv2wxj75azx3">
      <div className="mx-auto w-full max-w-5xl" data-id="element-21" data-mp="2hu39wl2xz8c6">
        <header className="mx-auto mb-8 max-w-3xl text-center" data-id="element-22" data-mp="2hxhbhr3s7dik">
          <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.2em] text-lime sm:text-xs" data-id="element-23" data-mp="2mswropp9hli5">
            🦷 The author
          </p>
          <h2 className="font-display text-2xl leading-tight text-white sm:text-4xl" data-id="element-24" data-mp="2wsdrwrlqv76q">
            About Dra. Karito &amp; the Anti-Refinement System™
          </h2>
        </header>

        <div className="grid items-center gap-6 md:grid-cols-[minmax(0,320px)_1fr]" data-id="element-25" data-mp="xhcpq3kqbvj8">
          <div className="mx-auto w-full max-w-[280px] md:max-w-none" data-id="element-26" data-mp="12emmk4ag79h3">
            <div className="overflow-hidden rounded-3xl border border-lime/25 bg-ink-800" data-id="element-27" data-mp="ls5xi3bt3w41">
              <img src={KARITO_IMAGE} alt="Dra. Karito, creator of the Anti-Refinement System" className="aspect-[3/4] w-full object-cover" loading="lazy" data-id="element-28" data-mp="h04bvqsr0t1c" />
            </div>
            <p className="mt-3 text-center font-display text-lg text-lime" data-id="element-29" data-mp="70dixtju6m3d">Dra. Karito</p>
            <p className="text-center text-xs text-white/55" data-id="element-30" data-mp="14nw27yb4j6lm">
              Clear aligner clinician &amp; creator of the Anti-Refinement System™
            </p>
          </div>

          <div data-id="element-31" data-mp="uqhpo9sbn1yl">
            <p className="text-sm leading-relaxed text-white/75 sm:text-base" data-id="element-32" data-mp="upzjolfux9dh">
              The Anti-Refinement System™ was created around a simple clinical idea:{' '}
              <span className="font-bold text-lime" data-id="element-33" data-mp="3fj31a7t4z6e5">
                don’t wait for the case to fail before deciding what went wrong.
              </span>
            </p>
            <p className="mt-3 text-sm leading-relaxed text-white/65" data-id="element-34" data-mp="3cxv9ev2eqyyg">
              Refinements often become necessary because problems were already present much earlier
              in the process. A movement may have been difficult to express. A setup may have looked
              ideal digitally but lacked clinical predictability. An attachment may not have provided
              the control the movement required. A tracking problem may have been visible weeks
              before it became obvious.
            </p>
            <p className="mt-3 text-sm leading-relaxed text-white/65" data-id="element-35" data-mp="2yyvs68h85mcb">
              The system brings these decisions together into one practical clinical reference.
            </p>

            <ul className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-36" data-mp="2p77x7xlgln63">
              {principles.map(item => <li key={item} className="flex items-center gap-2 rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-3" data-id="element-37" data-mp="2b7zuwvu01yxo">
                  <CheckIcon className="h-4 w-4 shrink-0 text-lime" data-id="element-38" data-mp="1wl1515asjcl2" />
                  <span className="text-sm text-white/80" data-id="element-39" data-mp="1wndwc92fuzas">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto max-w-md" data-id="element-40" data-mp="25nad7oil6tva">
          <SectionCta headline="Get the reference Dra. Karito uses across the entire aligner workflow." data-id="element-41" data-mp="25juxqkl03itc" />
        </div>
      </div>
    </section>;
}